import APIError from '../APIError';

class AddressError extends APIError {
  constructor(code, details = null) {
    super(code, 'AddressError', details);
  }
}

export default AddressError;
